<template lang="html">
  <nav v-if="$route.name !== 'home'">
    <div class="logomenu">
      <router-link class="logo" :to="{ name: 'home' }">
        <img src="@/assets/luma-westbau-logo.svg" alt="Luma Westbau" />
      </router-link>
    </div>
    <div class="mobile-menu-btn" @click="toggleMenu">Menu</div>
    <div class="menu-links">
      <router-link
        class="menu-link"
        v-for="page in pages"
        :key="page.uid"
        :to="{ name: page.uid }"
      >
        {{ page.title }}
      </router-link>
    </div>
    <locale-switcher />
  </nav>
</template>

<script>
import API from "@/api/service";
const LocaleSwitcher = () =>
  import(
    /* webpackChunkName: "LocaleSwitcher" */ "@/components/LocaleSwitcher.vue"
  );
export default {
  components: {
    LocaleSwitcher,
  },
  data() {
    return {
      pages: [],
      mobileMenu: false,
    };
  },
  mounted() {
    this.$root.$on("toggleMenu", this.resetMenu);
  },
  watch: {
    $route(to, from) {
      // console.log();
      if (to.params.lang !== from.params.lang) {
        API.pages(this.$i18n.locale).then((page) => {
          this.pages = page.data.result.data;
        });
      }
    },
  },
  created() {
    API.pages(this.$i18n.locale).then((page) => {
      this.pages = page.data.result.data;
    });
  },
  methods: {
    toggleMenu() {
      if (this.mobileMenu) {
        this.$root.$emit("toggleMenu", false);
        this.mobileMenu = false;
      } else {
        this.$root.$emit("toggleMenu", true);
        this.mobileMenu = true;
      }
    },
    resetMenu(value) {
      this.mobileMenu = value;
    },
  },
};
</script>

<style lang="scss" scoped>
nav {
  position: fixed;
  z-index: 20;
  bottom: calc(0.5 * var(--lh));
  left: 0;
  width: 100%;
  background: var(--bg);
  height: calc(2 * var(--lh));
  display: grid;
  padding: calc(0.5 * var(--lh)) var(--lh);
  grid-template-columns: repeat(12, 1fr);
  // grid-template-columns: calc(250px - var(--lh)) repeat(7, 1fr);
  grid-gap: var(--lh);
  transition: transform 0.5s;
  text-transform: uppercase;
  @media only screen and (max-width: 768px) {
    grid-template-columns: repeat(8, 1fr);
  }
  .menu-links {
    display: flex;
    justify-content: space-between;
    grid-column: span 6;
    @media only screen and (max-width: 768px) {
      display: none;
    }
  }
  .logomenu {
    position: relative;
    grid-column: span 3;
    top: calc(-0.25 * var(--lh));
    @media only screen and (max-width: 768px) {
      grid-column: span 2;
    }
    img {
      height: calc(1.5 * var(--lh));
      display: block;
      width: auto !important;
    }
  }
  .mobile-menu-btn {
    display: none;
    cursor: pointer;
    @media only screen and (max-width: 768px) {
      display: block;
      grid-column: span 4;
      text-align: center;
    }
  }
  a {
    // padding: calc(0.5 * var(--lh)) 0;
    &.menu-link {
      @media only screen and (max-width: 768px) {
        display: none;
      }
    }
    &.logo {
      padding: calc(0.1 * var(--lh)) 0;
    }
  }
}
</style>
